import React, { useEffect, useState } from 'react';
import { X, Zap } from 'lucide-react';
import useSiteSettings from '../hooks/use-site-settings';
import { visit } from '../lib/visits';

const KEY = 'pp_promo_bar_closed';
const BAR_HEIGHT = 40;

const dateBr = (iso) => new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });

/**
 * Faixa no topo do site enquanto houver uma promoção valendo (ex.: Black Friday). O texto automático usa o nome da
 * promoção, o maior desconto e a data final; no admin ("Conteúdo do site") dá para trocar o texto. Some sozinha quando
 * a promoção termina e pode ser fechada pelo visitante (volta na próxima visita).
 */
const PromoBar = () => {
  const cfg = useSiteSettings();
  const bar = cfg?.promo_bar;
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    try { setClosed(sessionStorage.getItem(KEY) === bar?.label); } catch { /* sem armazenamento */ }
  }, [bar?.label]);

  const over = bar?.ends_at && Date.now() >= Date.parse(bar.ends_at);
  const show = Boolean(bar) && !closed && !over;

  // O menu fixo e a página descem a altura da faixa; sem faixa, nada muda.
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--pp-bar', show ? `${BAR_HEIGHT}px` : '0px');
    document.body.style.paddingTop = show ? `${BAR_HEIGHT}px` : '';
    window.__ppPromo = show ? (bar?.label || 'promo') : ''; // marca os eventos de visita durante a promoção
    return () => { root.style.removeProperty('--pp-bar'); document.body.style.paddingTop = ''; window.__ppPromo = ''; };
  }, [show, bar?.label]);

  if (!show) return null;
  const text = bar.text
    || `${bar.label}: até ${String(bar.percent).replace('.', ',')}% OFF${bar.ends_at ? ` · até ${dateBr(bar.ends_at)}` : ''}`;

  const close = () => {
    setClosed(true);
    try { sessionStorage.setItem(KEY, bar.label); } catch { /* ignora */ }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-3 px-10 text-center" style={{ height: BAR_HEIGHT, background: 'linear-gradient(90deg,#0f0f10,#1d1d22)' }} role="region" aria-label="Promoção">
      <a href="#loja" onClick={() => visit('click_promo', { label: bar.label })} className="inline-flex items-center gap-2 text-[13px] sm:text-sm font-bold text-[#FFD43B] hover:text-white transition truncate">
        <Zap className="w-4 h-4 shrink-0" fill="currentColor" />
        <span className="truncate">{text}</span>
        <span className="hidden sm:inline rounded-full bg-[#FFD43B] text-[#0f0f10] text-xs font-extrabold px-2.5 py-0.5">Aproveitar</span>
      </a>
      <button type="button" onClick={close} aria-label="Fechar aviso" className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-white/60 hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default PromoBar;
